import { GET_VL_CONNECT_ACTIVITY_REPORT } from '../../../Types'
import _ from 'lodash'



const VLConnectActivityReportReducer = (state = [], action) => {
  switch (action.type) {
    case GET_VL_CONNECT_ACTIVITY_REPORT:
  return {
    ...state,
    data: action.payload?.data || [],          // Make sure this exists
    totalRecords: action.payload?.totalRecords || 0, // And this exists
  };
    default:
      return state
  }
}
export default VLConnectActivityReportReducer